<% if (aee.link == 'terminal') { %>
<%- include('/ui/form', {
	params: [ 'aee_link_2', aee ],
	fields: [
		{
			type: 'select',
			name: 'terminal_id',
			title: 'Terminál',
			params: {
				maxItems: 1,
				options: Anvil.page.terminals.data.filter(x => x.company_id == aee.company_id),
				optgroups: Anvil.page.modal.company_dbs.data.map(x => ({ value: x.id, label: x.db_name })),
				optgroupField: 'company_db_id',
				valueField: 'machine_id',
				labelField: 'name',
				searchField: [ 'name' ],
				render: {
					item: (item, esc) => `<div>${esc(item.name)}<br /><small><i class="fa fa-fw fa-sm fa-${Anvil.models.c_order.Site.Types.find(t => t.value == item.site_type).icon} me-1"></i>${esc(item.site_name)}</small></div>`,
					option: (item, esc) => `<div class="option">${esc(item.name)}<br /><small><i class="fa fa-fw fa-sm fa-${Anvil.models.c_order.Site.Types.find(t => t.value == item.site_type).icon} me-1"></i>${esc(item.site_name)}</small></div>`
				}
			},
			unset_value: null
		}
	]
}) %>
<% } %>
